import React from "react";

import { FormInstance } from "antd/lib/form";

import { Client } from "../../../../bitmaker/schemas/Billing/Client";

import { InvoiceAmountDue } from "./Sidebar/InvoiceAmountDue";
import { InvoiceClientSelector } from "./Sidebar/InvoiceClientSelector";
import { InvoiceDatesAndRef } from "./Sidebar/InvoiceDatesAndRef";
import { InvoiceNumberField } from "./Sidebar/InvoiceNumberField";

interface InvoiceSidebarProps {
  form: FormInstance;
  clients: Client[];
  loadingClients: boolean;
  fetchClientsError: string | null;
}

export const InvoiceSidebar: React.FC<InvoiceSidebarProps> = ({
  form,
  clients,
  loadingClients,
  fetchClientsError,
}) => {
  return (
    <div className="col-span-3 py-10 grid grid-cols-12">
      <div className="col-start-3 col-span-10 space-y-6 text-right">
        {/* Amount Due */}
        <InvoiceAmountDue form={form} />
        {/* Billed To/Client */}
        <InvoiceClientSelector
          form={form}
          clients={clients}
          loadingClients={loadingClients}
          fetchClientsError={fetchClientsError}
        />
        {/* Invoice Number */}
        <InvoiceNumberField />
        {/* Date of Issue, Due Date and Reference */}
        <InvoiceDatesAndRef form={form} />
      </div>
    </div>
  );
};
